const orderSizeFacets = (items)=>{
    const sortOrder = [
        'EXTRA_SMALL',
        'SMALL',
        'MEDIUM',
        'LARGE'
    ];
    var ref;
    return (ref = items.sort((a, b)=>{
        const aIndex = sortOrder.indexOf(`${a.facetTerm}`);
        const bIndex = sortOrder.indexOf(`${b.facetTerm}`);
        return aIndex - bIndex;
    })) !== null && ref !== void 0 ? ref : [];
};

export { orderSizeFacets };
//# sourceMappingURL=order-size-facets.js.map
